import React, { useEffect, useState } from 'react';
import { WifiOff, Wifi } from 'lucide-react';
import { useNetwork } from '../../hooks/useNetwork';

/**
 * OfflineBanner — slim animated banner that appears when the device goes offline
 * and briefly shows a "Back Online" confirmation when reconnected.
 */
const OfflineBanner = () => {
  const { isOnline } = useNetwork();
  const [wasOffline, setWasOffline] = useState(false);
  const [showReconnected, setShowReconnected] = useState(false);

  useEffect(() => {
    if (!isOnline) {
      setWasOffline(true);
      setShowReconnected(false);
    } else if (wasOffline) {
      setShowReconnected(true);
      const t = setTimeout(() => {
        setShowReconnected(false);
        setWasOffline(false);
      }, 3000);
      return () => clearTimeout(t);
    }
  }, [isOnline, wasOffline]);

  if (isOnline && !showReconnected) return null;

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-[9999] flex items-center justify-center gap-2 py-2.5 px-4 text-sm font-medium transition-all duration-500 ${
        isOnline
          ? 'bg-emerald-500 text-white'
          : 'bg-gray-900 text-white'
      }`}
      style={{ paddingTop: 'env(safe-area-inset-top, 0px)' }}
    >
      {isOnline ? (
        <>
          <Wifi size={15} className="shrink-0" />
          <span>Back online</span>
        </>
      ) : (
        <>
          <WifiOff size={15} className="shrink-0 animate-pulse" />
          <span>You're offline — some features may be limited</span>
        </>
      )}
    </div>
  );
};

export default OfflineBanner;
